/**
 * @desc 获取IOT管理域下拉列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.IotBaseResult>>> {
  return defHttp.post({
    url: '/web/alert/rule/listOrgCode',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.IotBaseResult>>> {
  return defHttp.post({
    url: '/mock/web/alert/rule/listOrgCode',
  });
}
